import { getCurrentDate } from "./currentDate";
export function autoAddRemoveBy(startDate, endDate, callback) {
    const currentDate = getCurrentDate();
    if (startDate && currentDate < startDate) {
        return false;
    }
    else if (endDate && currentDate > endDate) {
        return false;
    }
    if (typeof callback === "function") {
        callback();
    }
    return true;
}
